/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
/**
 * Converting the SVG to Data URI
 */
// [DLS TODO]: Refactor conversion expression to use @ion/core/src/utils/Encoding.ts module
export const convertSvgToDataUri = (svg: string): string => {
  return `data:image/svg+xml;base64,${btoa(svg.trim())}`;
};

/**
 * Provides an utility to Normalize a string with special characters(Non-English)
 * ```typescript
 *
 * import {convertBase64ToString} from '@ion/core/src/utils/Encoding';
 *
 * convertBase64ToString('UGHtcw=='); // País;
 */
export const convertBase64ToString = (str: string, encoding: string = 'utf-8'): string => {
  return Buffer.from(str, 'base64').toString(encoding as any);
};
